import { neutral6 } from '../../colors';

export const classes = {
  root: {
    maxHeight: 40,
  },
  positionStart: {
    position: 'absolute',
    marginLeft: 6,
    color: neutral6,
  },
  positionEnd: {
    position: 'absolute',
    right: 1,
    marginRight: 4,
  },
};
